/**
 * form
 *
 * @author Shigq
 * @date 2021/4/20 10:37
 */
import { reactive } from 'vue'

import common from '@/compositions/modules/common'
import { commonUtils, currencyUtils, validator } from '@libs/utils'

/**
 * assemble form
 *
 * @param items
 * @returns {{rules: {}, fields: {}}}
 */
const assembleForm = function(items) {
  const _fields = {}
  const _rules = {}
  const _schema = {}

  try {
    if (items && items.length > 0) {
      items.forEach(item => {
        if (item) {
          _fields[item.prop] = item.default
          _schema[item.prop] = item

          const rules = item.rules

          if (rules) {
            _rules[item.prop] = rules
          }
        }
      })
    }

    return {
      fields: _fields,
      rules: _rules,
      schema: _schema
    }
  } catch (e) {
    throw new Error(`form.js#assembleForm failed! \n ${e.toString()}`)
  }
}

export default function() {
  const { dict: { currency } } = common()

  // todo - composition
  const scopedComp = {
    currency
  }

  // todo - methods
  const scopedMethods = {
    /**
     * create form
     *
     * @param items
     * @returns {*}
     */
    createForm: ({ items = [] } = {}) => {
      /* 保证数据原子性 */
      const currItems = commonUtils.clone(items)

      const { fields, rules, schema } = assembleForm(currItems)

      return reactive({
        fields,
        rules,
        schema,
        items
      })
    },
    /**
     * reset form
     *
     * @param form
     */
    resetForm: form => {
      Object.keys(form.fields).forEach(item => {
        form.fields[item] = form.schema[item]?.default
      })
    },
    /**
     * reset form by fields
     *
     * @param form
     */
    resetFormByFields: (form, fields) => {
      Object.keys(form.fields).forEach(item => {
        if (fields.includes(item)) {
          form.fields[item] = form.schema[item].default
        }
      })
    }
  }

  // todo - handle
  const scopedHandlers = {
    handleAmountFocus(target, attr) {
      target[attr] = currencyUtils.reformatMoney(target[attr])
    },
    handleAmountBlur(target, attr, curId) {
      let places = 2

      if (!validator.isPositiveNumber(target[attr])) {
        target[attr] = ''
        return
      }

      // 无小数位的币种
      if (!commonUtils.isEmpty(curId)) {
        places = scopedComp.currency.map[curId].decPoint

        if (places === 0) {
          target[attr] = parseInt(target[attr])
        }
      }

      target[attr] = currencyUtils.formatMoney(target[attr], places, '')
    }
  }

  return {
    ...scopedMethods,
    ...scopedHandlers
  }
}
